import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dealer-list-details',
  templateUrl: './dealer-list-details.component.html',
  styleUrls: ['./dealer-list-details.component.scss', '../dealer-list.component.scss'],
  standalone: false,
})
export class DealerListDetailsComponent implements OnInit {
  @Input() list: any;
  @Input() isShipTo = false;

  constructor() {}

  ngOnInit(): void {}
}
